const getFormattedDateForDownloads = () => {
  const date = new Date();
  const formatNumber = (number: number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}${formatNumber(date.getMonth() + 1)}${formatNumber(date.getDate())} ${formatNumber(date.getHours())}${formatNumber(date.getMinutes())}`;
};

export default getFormattedDateForDownloads;
